// Ödeme Linkleri ekranının yardımcıları.
// Daha önce PaymentLinkTable.js içinde gömülü olan mantık birebir buraya taşındı.

/** 18.05.2026 */
export const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("tr-TR", { year: "numeric", month: "2-digit", day: "2-digit" }) : "-";

/** 15:04 */
export const formatTime = (d) =>
    d ? new Date(d).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) : "";

/** 18.05.2026 15:04 */
export const formatDateTime = (d) => (d ? `${formatDate(d)} ${formatTime(d)}` : "-");

export const isExpired = (expiryDate) => !!expiryDate && new Date(expiryDate) < new Date();

/** Sabit (FIXED) link kullanım limitini doldurmuş mu */
export const isFixedLinkUsedUp = (link) =>
    link?.maxUsageCount != null && link.paymentCount >= link.maxUsageCount;

export const truncateUrl = (url, max = 60) =>
    !url ? "-" : url.length > max ? `${url.substring(0, max)}...` : url;

/** Link adresinin son parçası (ONE_TIME'da id, FIXED'de public token) */
export const extractLinkCode = (url) => {
    if (!url) return "-";
    const clean = url.split("?")[0].replace(/\/+$/, "");
    const parts = clean.split("/");
    return parts[parts.length - 1] || "-";
};

/**
 * Linkin durum rozeti. ONE_TIME ve FIXED linkler için mevcut iş kuralları
 * değiştirilmeden korunmuştur.
 * @returns {{label: string, chipClass: string}}
 */
export const getLinkStatus = (link) => {
    if (!link) return { label: "-", chipClass: "chip-gray" };

    // Silme her iki link tipinde de geçerli, bu yüzden süre/limit gibi diğer
    // kuralların ÖNÜNDE değerlendirilir; aksi hâlde silinmiş bir link "Aktif"
    // rozetiyle görünürdü. Silinmiş satırı yalnızca süper admin görebilir.
    if (link.deleted) return { label: "Silindi", chipClass: "chip-gray" };

    if (link.linkType === "FIXED") {
        if (link.status === "PAUSED") return { label: "Duraklatıldı", chipClass: "chip-amber" };
        if (link.status === "SUSPENDED") return { label: "Askıya Alındı", chipClass: "chip-red" };
        if (isExpired(link.expiryDate)) return { label: "Süresi Dolmuş", chipClass: "chip-gray" };
        if (isFixedLinkUsedUp(link)) return { label: "Limit Doldu", chipClass: "chip-gray" };
        return { label: "Aktif", chipClass: "chip-green" };
    }

    if (isExpired(link.expiryDate)) return { label: "Süresi Dolmuş", chipClass: "chip-gray" };
    if (link.userPaid) return { label: "Tamamlandı", chipClass: "chip-green" };
    if (link.userClicked) return { label: "Beklemede", chipClass: "chip-amber" };
    return { label: "Aktif", chipClass: "chip-navy" };
};

/** Tıklanma rozeti. Sayaç varsa etikette tıklanma adedi gösterilir. */
export const getClickedChip = (link) => {
    const count = link?.clickCount || 0;
    return link?.userClicked
        ? { label: count > 0 ? `${count} tıklanma` : "Tıklandı", chipClass: "chip-green", icon: "bx-mouse" }
        : { label: "Tıklanmadı", chipClass: "chip-amber", icon: "bx-mouse" };
};

/**
 * Ödeme rozeti. FIXED linklerde ödeme sayısı (limit varsa limitle birlikte),
 * ONE_TIME linklerde ödendi/ödenmedi bilgisi gösterilir.
 */
export const getPaymentChip = (link) => {
    if (link?.linkType === "FIXED") {
        const limit = link.maxUsageCount != null ? ` / ${link.maxUsageCount}` : "";
        return {
            label: `${link.paymentCount || 0}${limit} ödeme`,
            chipClass: link.paymentCount > 0 ? "chip-green" : "chip-amber",
            icon: "bx-credit-card",
        };
    }
    return link?.userPaid
        ? { label: "Ödendi", chipClass: "chip-green", icon: "bx-credit-card" }
        : { label: "Ödenmedi", chipClass: "chip-red", icon: "bx-credit-card" };
};

/**
 * Sabit linkler duraklatılabilir/aktifleştirilebilir ve adresi yenilenebilir (backend kısıtı).
 * İki uç da yalnız SUPER_ADMIN, COMPANY_ADMIN ve COMPANY_ACCOUNTANT'a açık; diğer roller 403 görürdü.
 * Silinmiş linkte gizlenir: silme geri alınamadığı için buton 404 alırdı.
 */
const LINK_STATUS_ROLES = ["ROLE_SUPER_ADMIN", "ROLE_COMPANY_ADMIN", "ROLE_COMPANY_ACCOUNTANT"];

export const canToggleLinkStatus = (link, roles) =>
    link?.linkType === "FIXED"
    && !link?.deleted
    && Array.isArray(roles)
    && roles.some((r) => LINK_STATUS_ROLES.includes(r));

/**
 * Silme yetkisi. Backend bu ucu SUPER_ADMIN ve COMPANY_ADMIN ile sınırlar
 * (muhasebeci yalnızca geri alınabilir olan duraklatmayı yapabilir), bu yüzden
 * menü de aynı rollerde açılır — aksi hâlde kullanıcı 403 görürdü.
 */
export const canManagePaymentLink = (roles) =>
    Array.isArray(roles) && (roles.includes("ROLE_SUPER_ADMIN") || roles.includes("ROLE_COMPANY_ADMIN"));

/** Silinebilir mi: yetki var ve link henüz silinmemiş. */
export const canDeleteLink = (link, roles) => canManagePaymentLink(roles) && !link?.deleted;
